import { useNavigationManager } from '@provider/navigation';
import { useMatchBreakpoint, Chevron } from '@utils/react';
import { userAreaBreakpoints } from '../../../const.breakpoints.js';
import { headerCls, headingCls } from '../../../layout/content.style.js';
import { contentWrapperCls } from './_page.style.js';
import { FontGroup } from './molecule.group.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FontPane() {
  const isMobile = useMatchBreakpoint(userAreaBreakpoints.mobile);
  const navigation = useNavigationManager();
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx("header", {
      className: headerCls,
      children: /*#__PURE__*/jsx("h1", {
        className: headingCls,
        children: isMobile ? /*#__PURE__*/jsxs("button", {
          "aria-label": "G\xE5 tilbage til oversigt",
          onClick: () => navigation.push("/"),
          children: [/*#__PURE__*/jsx(Chevron, {
            inversed: true,
            size: 12
          }), "Indstil skrifttype"]
        }) : "Indstil skrifttype"
      })
    }), /*#__PURE__*/jsx("div", {
      className: contentWrapperCls,
      children: /*#__PURE__*/jsx(FontGroup, {})
    })]
  });
}

export { FontPane };
//# sourceMappingURL=_page.js.map
